import CreativeCardContainer from "../../Componant/BonusUI/CreativeCard";

const CreativeCard = () => {
  return (
    <div className="page-body">
      <CreativeCardContainer />
    </div>
  );
};

export default CreativeCard;
